import { createContext, type PropsWithChildren } from 'react';
import { detectDeviceInfo } from '@djs/detectDeviceInfo';
import type { AppContextState } from './types';
import { initialState } from './consts';
import { getDomainZone } from '../../utils/domain';

export const AppContext = createContext<AppContextState>(initialState);

export function AppContextProvider(props: PropsWithChildren) {
  const { children } = props;

  return (
    <AppContext.Provider
      value={{
        domainZone: getDomainZone(window.location.host),
        deviceInfo: detectDeviceInfo(navigator.userAgent || ''),
      }}
    >
      {children}
    </AppContext.Provider>
  );
}
